export default __webpack_public_path__ + "static/media/arrow-up.fb1aab50.svg";